import React from 'react';
import { useSelector } from 'react-redux';

import { selectTrayComponent, selectTrayProps } from '../../redux/modules/tray';

import TrayContainer from './TrayContainer';

function Tray() {
  const Component = useSelector(selectTrayComponent);
  const trayProps = useSelector(selectTrayProps);

  if (!Component) return null;

  return (
    <TrayContainer>
      <Component {...trayProps} />
    </TrayContainer>
  );
}

export default Tray;
